export const hash = false;
export const lang = "ru";
export const i18n = {
    ru: {
        CLOSE: "Закрыть",
        NEXT: "Вперед",
        PREV: "Назад",
        ERROR: "Ошибка при загрузке. <br/> Пожалуйста, повторите позже.",
        PLAY_START: "Слайдшоу",
        PLAY_STOP: "Остановить",
        FULL_SCREEN: "Во весь экран",
        THUMBS: "Превью",
        DOWNLOAD: "Скачать",
        SHARE: "Поделиться",
        ZOOM: "Увеличить"
    }
};

